const state = () => ({
    items: [], // آرایه محصولات سبد خرید
})

const mutations = {
    ADD_TO_CART(state, product) {
        const existing = state.items.find(item => item.id === product.id)
        if (existing) {
            existing.quantity += product.quantity || 1
        } else {
            state.items.push({ ...product, quantity: product.quantity || 1 })
        }
    },
    REMOVE_FROM_CART(state, productId) {
        state.items = state.items.filter(item => item.id !== productId)
    },
    CLEAR_CART(state) {
        state.items = []
    }
}

const actions = {
    addToCart({ commit }, product) {
        commit('ADD_TO_CART', product)
    },
    removeFromCart({ commit }, productId) {
        commit('REMOVE_FROM_CART', productId)
    },
    clearCart({ commit }) {
        commit('CLEAR_CART')
    }
}

const getters = {
    cartItems: (state) => state.items,
    cartTotal: (state) =>
        state.items.reduce((total, item) => total + item.price * item.quantity, 0),
    cartCount: (state) =>
        state.items.reduce((count, item) => count + item.quantity, 0),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
